<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; {{ date }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire',
      }],
      date: moment().format('YYYY'),
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'WikiSchool - QR Code Scanner',
    };
  },
  name: 'App',
};
</script>



// WEBPACK FOOTER //
// src/App.vue